import React from "react";
import { FaWhatsapp, FaInstagram } from "react-icons/fa";
import "./header.css";
import links from "../../../links/allLinks";

const Header = () => {
  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  return (
    <header className="header">
      <h1 className="title App-logo-font">RAWGR</h1>
      <div className="button-container-header">
        <Button
          icon={<FaWhatsapp />}
          text="Join Us"
          buttonLink={links
            .filter((item) => isMobile ? item.rawgrWhatsAppGroupLink : item.rawgrWhatsAppWebGroupLink)
            .map((item) => isMobile ? item.rawgrWhatsAppGroupLink : item.rawgrWhatsAppWebGroupLink)}
        />
        <Button
          icon={<FaInstagram />}
          text="Follow Us"
          buttonLink={links
            .filter((item) => item?.rawgrInstagramLink)
            .map((item) => item.rawgrInstagramLink)}
        />
      </div>
    </header>
  );
};

const Button = ({ icon, text, buttonLink }) => {
  return (
    <button
      className="custom-button"
      onClick={() => {
        window.open(buttonLink);
      }}
    >
      <span className="icon">{icon}</span>
      {text}
    </button>
  );
};

export default Header;
